import { render, staticRenderFns } from "./MemberInfoExpand.vue?vue&type=template&id=5112e3b9"
import script from "./MemberInfoExpand.vue?vue&type=script&lang=js"
export * from "./MemberInfoExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports